/**
 * Airband Radio tab of the right panel (ENG-340). No audio or transcript
 * source exists yet, so this is the empty state; the tab and its unread counter
 * are in place for when one is wired.
 */
export function AirbandPane() {
  return (
    <div className="flex flex-col h-full items-center justify-center px-6 text-center">
      <div className="text-[0.846em] font-semibold text-(--color-text2)">Airband Radio</div>
      <div className="text-[0.769em] text-(--color-text3) mt-1">No radio source connected yet.</div>
    </div>
  );
}
